// Identity helpers for participant avatars. Deliberately brand-independent
// (DESIGN.md: never rely on orange semantics) — a fixed, theme-agnostic palette
// that reads on both the light and dark sidebar.
const AVATAR_PALETTE = [
  "hsl(209 70% 42%)",
  "hsl(265 42% 52%)",
  "hsl(150 45% 38%)",
  "hsl(330 48% 50%)",
  "hsl(190 58% 36%)",
  "hsl(45 58% 42%)",
  "hsl(0 55% 52%)",
  "hsl(280 42% 48%)",
]

export function getParticipantInitials(name: string | undefined): string {
  const trimmed = (name ?? "").trim()
  if (!trimmed) return "?"
  const parts = trimmed.split(/\s+/)
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase()
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function getParticipantColor(key: string | undefined): string {
  const value = key ?? ""
  let hash = 0
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length]
}
